<template>
  <div
    id="app"
    :class="{
      'custom-header-footer': $config.customHeaderAndFooter
    }"
  >
    <ogs-header
      v-if="$config.customHeaderAndFooter"
    />
    <LocaleChanger />
    <div
      v-if="initiating"
      id="page"
      class="d-flex justify-content-center"
    >
      <div
        class="spinner-border text-secondary mb-3"
        role="status"
      />
      <span class="text-secondary">
        Chargement ...
      </span>
    </div>
    <router-view
      v-else
      id="page"
    />
    <ConfirmationModal />
    <ogs-footer
      v-if="$config.customHeaderAndFooter"
    />
  </div>
</template>

<script>
import usergroupsAPI from '@/api/usergroupsAPI';
import modal from '@/utils/modal.js';

import ConfirmationModal from '@/components/ConfirmationModal.vue';
import LocaleChanger from '@/components/LocaleChanger.vue';
import loginAPI from '@/api/loginAPI.js';
export default {
  components: {
    ConfirmationModal,
    LocaleChanger,
  },

  data() {
    return {
      initiating: true,
      usergroupsTypes: []
    };
  },

  async created() {
    try {
      await loginAPI.session();
      /*
      const types = await usergroupsAPI.getUsergroupsTypes();
      this.usergroupsTypes = types || [];
      for (const usergroupsType of this.usergroupsTypes) {
        // prefetch lists for each type to warm caches in the API layer
        await usergroupsAPI.getUsergroupsList([usergroupsType.choice]);
      }
      */
    } catch (e) {
      // ignore errors here; components will fetch as needed
      console.error(e);
    } finally {
      // After session init (if Ok/logged or Failed/anonymous)
      // JWT Authentication (code for both RP and IDP)
      const urlParams = new URLSearchParams(window.location.search);
      const jwttoken = urlParams.get('jwttoken');
      const next = urlParams.get('next') || process.env.VUE_APP_NEXT_DEFAULT;
      const nextForwarded = urlParams.get('nextForwarded');

      if (loginAPI.logged) {
        // Executed on IDP
        if (
          nextForwarded && this.$config.authorizedRedirections.some(reg => {
            return reg.test(decodeURIComponent(next))
          })
        ) {
          // The IDP return to RP with JWT token (Called from RP with param nextForwarded)
          window.location.href = next + "?next=" + nextForwarded + "&jwttoken=" + loginAPI.token;
          return;
        }
      } else {
        // Executed on RP
        if (jwttoken) {
          // The RP manage JWT Token send by IDP
          try {        
            const response = await loginAPI.signInWithToken({jwttoken: jwttoken});
            if (response.status && response.status !== 200) {
              console.error("ERROR signInWithToken ::", response.data)
            }
          } catch (error) {
            console.error('Failed to sign in with token:', error);
          } finally {
            // Remove the token and next from the URL even if it fails
            urlParams.delete('jwttoken');
            urlParams.delete('next');
            const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
            window.history.replaceState({}, '', newUrl);
            // Always redirect to next even with error ...
            window.location.href = next;
            return;
          }
        } else {
          // The RP Redirect to main IDP - try to get token
          // bypass RP Login
          const idphost = this.$config.idp?.host || process.env.VUE_APP_IDP_HOST;
          if (idphost) {
            window.location.href = idphost + "?next=" + window.location.origin + window.location.pathname + "&nextForwarded="+ next;
            return;
          }
        }
      }
      //
      
      this.initiating = false;
    }
  },

  mounted() {
    // Watch modal closing event
    this.$root.$on('bv::modal::hide', (e) => {
      // ensure the modal state is closed when bootstrap-vue emits hide
      // (componentId looks like "confirmation-modal")
      modal.closeConfirmation();
    });
  },

  methods: {
    // modal is handled via the `modal` utility
  }
};
</script>
